import React, { useEffect, useState } from "react";
import {Form, Spinner  } from "react-bootstrap";
import { globalFormManagementServices } from "../../../../../APIServices/globalFormManagementServices";

const AddFormFieldGroupForm = ({getGlobalFormFieldGroup }) => {
  const [categoryLabel, setCategoryLabel] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [categoryCodeLabel, setCategoryCodeLabel] = useState("");
  const [categoryCodeName, setCategoryCodeName] = useState("");
  const [categoryValueLabel, setCategoryValueLabel] = useState("");
  const [categoryValueName, setCategoryValueName] = useState("");
  const [categoryUnitLabel, setCategoryUnitLabel] = useState("");
  const [categoryUnitName, setCategoryUnitName] = useState("");
  const [categoryRemarkLabel, setCategoryRemarkLabel] = useState("");
  const [categoryRemarkName, setCategoryRemarkName] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewGlobalFormFieldGroup = async () => {
    setButtonLoader(true);
    let userData = {}
    userData.categoryLabel = categoryLabel
    userData.categoryName = categoryName
    userData.categoryCodeLabel = categoryCodeLabel
    userData.categoryCodeName = categoryCodeName
    userData.categoryValueLabel = categoryValueLabel
    userData.categoryValueName = categoryValueName
    userData.categoryUnitLabel = categoryUnitLabel
    userData.categoryUnitName = categoryUnitName
    userData.categoryRemarkLabel = categoryRemarkLabel
    userData.categoryRemarkName = categoryRemarkName
    let data = await globalFormManagementServices.addNewGlobalFormFieldGroup(userData)
    if (data?.statusCode === 200) {
      clearForm()
      getGlobalFormFieldGroup()
    }
    setButtonLoader(false);
  }

  const clearForm = () => {
    setCategoryLabel("")
    setCategoryName("")
    setCategoryCodeLabel("")
    setCategoryCodeName("")
    setCategoryValueLabel("")
    setCategoryValueName("")
    setCategoryUnitLabel("")
    setCategoryUnitName("")
    setCategoryRemarkLabel("")
    setCategoryRemarkName("")
  }

  useEffect(() => {
    clearForm();
  }, []);

  return (
    <div className="p-2">
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryLabel(e.target.value)}
              value={categoryLabel}
              className="br3"
              placeholder="Enter Category Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                setCategoryName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={categoryName}
              className="br3"
              placeholder="Enter Category Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Code Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryCodeLabel(e.target.value)}
              value={categoryCodeLabel}
              className="br3"
              placeholder="Enter Category Code Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Code Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                setCategoryCodeName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={categoryCodeName}
              className="br3"
              placeholder="Enter Category Code Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Value Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryValueLabel(e.target.value)}
              value={categoryValueLabel}
              className="br3"
              placeholder="Enter Category Value Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Value Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                setCategoryValueName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={categoryValueName}
              className="br3"
              placeholder="Enter Category Value Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Unit Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryUnitLabel(e.target.value)}
              value={categoryUnitLabel}
              className="br3"
              placeholder="Enter Category Unit Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Unit Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                setCategoryUnitName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={categoryUnitName}
              className="br3"
              placeholder="Enter Category Unit Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Remark Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryRemarkLabel(e.target.value)}
              value={categoryRemarkLabel}
              className="br3"
              placeholder="Enter Category Remark Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Remark Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                setCategoryRemarkName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={categoryRemarkName}
              className="br3"
              placeholder="Enter Category Remark Name"
              type="text"
            />
          </Form.Group>
          <div className="text-end">
            <button
              disabled={!categoryCodeLabel || !categoryCodeName || !categoryLabel || !categoryName || buttonLoader || !categoryValueLabel || !categoryValueName || !categoryUnitLabel || !categoryUnitName || !categoryRemarkLabel || !categoryRemarkName}
              onClick={addNewGlobalFormFieldGroup}
               className={`updateProfile`}
              style={{ fontSize: 12 }}
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm"/> Adding...
                </div>
              ) : (
                "Add form field group"
              )}
            </button>
          </div>
    </div>
  );
};

export default AddFormFieldGroupForm;
